export default [
  { label: 'Ja', value: true },
  { label: 'Nein', value: false }
]
